if (!customElements.get('variant-selection-drawer')) {
  customElements.define(
    'variant-selection-drawer',
    class VariantSelectionDrawer extends HTMLElement {
      constructor() {
        super();

        this.trigger = this.querySelector('.sw-variant-drawer__trigger');
        this.panel = this.querySelector('.sw-variant-drawer__panel');
        this.closeButtons = this.querySelectorAll('[data-variant-drawer-close]');
        this.optionButtons = this.querySelectorAll('[data-variant-drawer-option]');
        this.previouslyFocusedElement = null;

        this.onTriggerClick = this.open.bind(this);
        this.onCloseClick = this.close.bind(this);
        this.onOptionClick = this.handleOptionClick.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);
      }

      connectedCallback() {
        this.trigger?.addEventListener('click', this.onTriggerClick);
        this.closeButtons.forEach((button) => button.addEventListener('click', this.onCloseClick));
        this.optionButtons.forEach((button) => button.addEventListener('click', this.onOptionClick));
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        this.closeButtons.forEach((button) => button.removeEventListener('click', this.onCloseClick));
        this.optionButtons.forEach((button) => button.removeEventListener('click', this.onOptionClick));
        document.removeEventListener('keydown', this.onKeyDown);
        if (this.classList.contains('is-open')) document.body.classList.remove('sw-variant-drawer-open');
      }

      open() {
        document.querySelectorAll('variant-selection-drawer.is-open').forEach((drawer) => {
          if (drawer !== this) drawer.close();
        });

        this.previouslyFocusedElement = document.activeElement;
        this.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('sw-variant-drawer-open');
        document.addEventListener('keydown', this.onKeyDown);

        const selectedOption = this.querySelector('[data-variant-drawer-option].is-selected');
        const focusTarget = selectedOption || this.panel;

        if (typeof trapFocus === 'function') {
          trapFocus(this.panel, focusTarget);
        } else {
          focusTarget?.focus();
        }
      }

      close() {
        this.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('sw-variant-drawer-open');
        document.removeEventListener('keydown', this.onKeyDown);

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.previouslyFocusedElement || this.trigger);
        } else {
          (this.previouslyFocusedElement || this.trigger)?.focus();
        }
      }

      handleKeyDown(event) {
        if (event.code?.toUpperCase() !== 'ESCAPE') return;
        event.preventDefault();
        this.close();
      }

      handleOptionClick(event) {
        const optionButton = event.currentTarget;
        const variantSelects = this.closest('variant-selects');
        if (!variantSelects) return;

        const nativeInputId = optionButton.dataset.nativeInput;
        const nativeSelectId = optionButton.dataset.nativeSelect;

        if (nativeInputId) {
          const nativeInput = this.getElementById(variantSelects, nativeInputId);
          nativeInput?.click();
        } else if (nativeSelectId) {
          const nativeSelect = this.getElementById(variantSelects, nativeSelectId);
          if (nativeSelect) {
            nativeSelect.value = optionButton.dataset.nativeValue;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        this.close();
      }

      getElementById(container, id) {
        if (window.CSS?.escape) return container.querySelector(`#${CSS.escape(id)}`);
        return Array.from(container.querySelectorAll('[id]')).find((element) => element.id === id);
      }
    }
  );
}
